const common = {
    facebookLink: "https://www.facebook.com/kulcheshulche",
    instagramLink: "https://www.instagram.com/kulcheshulche"
}

export default common;